import React, { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';

import { UserManagementProvider } from '../../contexts/UserManagementContext';
import Navigation from '../common/Navigation';
import Footer from '../common/Footer';
import ReloadProject from '../common/ReloadProject';
import TopHeader from '../common/TopHeader';
import pace from '../util/pace';
import { Tooltip } from 'react-tooltip';

import useAuthentication from '../../hooks/useAuthentication';

const MainLayout = () => {
    const location = useLocation()
    const wrapperClass = 'gray-bg ' + location.pathname;

    const { currentUser } = useAuthentication();
    const isAuthenticated = !!currentUser?.id;
    
    useEffect(() => {
        pace.start();
        // Take control of scroll restoration
        if (window.history.scrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }
        // Optional: Restore to 'auto' on unmount, though for a main layout this might not be strictly necessary
        return () => {
            if (window.history.scrollRestoration) {
                window.history.scrollRestoration = 'auto';
            }
        };
    }, []);
    
    useEffect(() => {
        const timerId = setTimeout(() => {
            if (document.activeElement && typeof document.activeElement.blur === 'function') {
                document.activeElement.blur();
            }
            // Try scrolling the main document bodies
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        }, 100); // Increased to 100ms delay
        return () => clearTimeout(timerId);
    }, [location.key]);

    return (
        <UserManagementProvider>
            <div id="wrapper">
                <Navigation location={location}/>
                <div id="page-wrapper" className={wrapperClass}>
                    {isAuthenticated && <TopHeader location={location}/>}
                    <Outlet />
                    {isAuthenticated && <Footer />}
                    <ReloadProject />
                    <Tooltip padding="4px" effect="solid" id="gnctooltip" className="gnctooltip" />
                </div>
            </div>
        </UserManagementProvider>
    )
};

export default MainLayout
